import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  span {
    font-size: 18px;
    font-weight: 600;
  }

  hr {
    width: 100%;
    opacity: 0.3;
  }
`;

export const Event = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;

  h2 {
    font-size: 16px;
    margin: 0;
  }

  span {
    font-size: 14px;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;

  button {
    width: 200px;
  }
`;

export const FormBlock = styled.div`
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;

  /* O Input global exige um <Form> do unform por volta; o form é o container
     real dos campos. */
  form {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  button {
    align-self: flex-end;
    width: 200px;
  }
`;

// --- Aprovação do cronograma + calendário ao lado (B04, 03/09/2026) ---------

export const Events = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

// Lista à esquerda, calendário à direita — só para o patrocinador (D13).
// Empilha no mobile: o calendário do react-day-picker não cabe ao lado da lista
// em telas estreitas.
export const SponsorLayout = styled.div`
  display: flex;
  gap: 24px;
  align-items: flex-start;
  width: 100%;

  > div:first-child {
    flex: 1;
  }

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const CalendarColumn = styled.div`
  width: 360px;
  max-width: 100%;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

export const Status = styled.span`
  align-self: flex-start;

  margin-top: 4px;
  padding: 2px 8px;
  border-radius: 4px;

  font-size: 12px;

  background-color: ${({ status, theme }) =>
    status === "Aprovado"
      ? theme.colors.primary.green
      : status === "Reprovado"
        ? theme.colors.feedback.error
        : theme.colors.primary.orange};
  color: ${({ theme }) => theme.colors.neutral.black};
`;

export const Locked = styled.p`
  margin-top: 4px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.neutral.cinza200};
`;

export const Helper = styled.p`
  margin: 4px 0 12px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.neutral.cinza200};
`;

// Período do projeto (03/09/2026): linha FIXA no topo da lista do cronograma.
// Não é evento — vem do formulário base do projeto e é somente leitura em
// qualquer perfil. A borda à esquerda a distingue dos eventos sem precisar de
// um selo, que aqui só significaria estado de aprovação.
export const Period = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  margin-bottom: 20px;
  padding: 10px 10px 10px 14px;

  border-left: 3px solid ${({ theme }) => theme.colors.primary.springGreen};

  h2 {
    font-size: 16px;
  }

  span {
    font-size: 14px;
  }
`;
